import { defaultOptions, type UploadOptions } from 'tus-js-client';

/** Delays between TUS attempts; their count bounds the retries. */
const TUS_RETRY_DELAYS_MS = [0, 1000, 3000, 5000, 10000];

/**
 * Retry options for one TUS upload. A server that is busy answers 429 with
 * Retry-After; the upload waits at least that long and tries again instead of
 * failing. Every other response keeps the tus-js-client default. Each upload
 * gets its own delays because tus-js-client reads an attempt's delay right
 * after `onShouldRetry` returned.
 */
export function tusUploadRetryOptions(): {
  retryDelays: number[];
  onShouldRetry: NonNullable<UploadOptions['onShouldRetry']>;
} {
  const retryDelays = [...TUS_RETRY_DELAYS_MS];
  return {
    retryDelays,
    onShouldRetry: (error, retryAttempt, options) => {
      const response = error.originalResponse;
      if (response?.getStatus() !== 429) {
        return defaultOptions.onShouldRetry!(error, retryAttempt, options);
      }
      const retryAfterMs = Number(response.getHeader('Retry-After')) * 1000;
      if (Number.isFinite(retryAfterMs)) {
        retryDelays[retryAttempt] = Math.max(
          retryDelays[retryAttempt],
          retryAfterMs
        );
      }
      return true;
    },
  };
}
